export class ListEffectivePoliciesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "DataCatalogPolicyResourceType",
            "format": ""
        },
        {
            "name": "namespacePath",
            "baseName": "namespacePath",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "datasetName",
            "baseName": "datasetName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListEffectivePoliciesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
